$(document).ready(function () { 
    // Assuming you have a function to make the jobs AJAX request
    function jobsAjaxRequest(jobs) {
        // $('.filter-result-row').append('<div id="loaderajax"><div class="loader-ajax"><div class="loader-wrap"><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div><div class="loader"><div class="dot"></div></div></div><div class="loader-text">Please wait</div></div></div>');        alert('Ajax call');
        // alert('Jobs Call');
        jQuery.ajax({
            url: WP.AJAX_URL,
            data: {
                action: 'peakmedia_jobs_ajax',
                paged: paged,
                jobs: jobs,
            },
            type: 'POST',
            success: function(result) {
                jQuery('.filter-result .vacancy-table .jobs-content').html(result);

                // Hide loader after AJAX request is complete
                setTimeout(() => {
                    // $('body').find('#loaderajax').remove();
                    $("#ajax-job-list .filter-reset #job-filter-reset").show();
                }, 100);
                $("#ajax-job-list .filter-reset #job-filter-reset").hide();
            }
        });
    }

    // Define the click event handler function for filter tag
    function jobsFilterTagClick() {
        var jobs = jQuery(this).data('name');
        // alert(jobs);
        paged = 1;
        jobsAjaxRequest(jobs);
    }

    // Attach the click event for filter tag
    jQuery('#ajax-job-list .filter-jobs a.tag').on('click', jobsFilterTagClick);

    // Click event for filter-reset button
    jQuery('#ajax-job-list .filter-reset #job-filter-reset').click(function() {
        // Remove the click event handler for filter tag
        jQuery('#ajax-job-list .filter-jobs a.tag').off('click', jobsFilterTagClick);

        // Show all jobs by making an AJAX request with no filters
        paged = 1;
        jobsAjaxRequest('');

        // Reattach the click event for filter tag after a delay
        setTimeout(function() {
            // Define the click event handler function for filter tag
            function jobsFilterTagClick() {
                var jobs = jQuery(this).data('name');
                // alert(jobs);
                paged = 1;
                jobsAjaxRequest(jobs);
            }

            // Attach the click event for filter tag
            jQuery('#ajax-job-list .filter-jobs a.tag').on('click', jobsFilterTagClick);
        }, 100);
    });
})